import { configAxios, errorResponse, successResponse, configAxiosEngelinkCredit, configAxiosCampaign } from '@/utils/api-instance';
import { surveyMonkeyAPIBaseURL } from '@/utils/end-points';
import { ENDPOINTS, PLAN_TYPE } from '@/utils/constants';
import { appendQueryString } from '@/utils';
import axios from 'axios';

export const successHandlerLogin = async ({ key }) => {
    const api = configAxios();
    await api.post(ENDPOINTS.REGISTER_LOGIN, {});
};
export const checkToken = async () => {
    const api = configAxios();
    const { data } = await api.get('check_token/');
    return data;
};
export const getCrossSaler = async () => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.PLANS}?search=cross_seller`);
    const plans = data;
    return plans;
};
export const getDescriptionPlans = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.PLANS_DESCRIPTIONS);
    const plans = data.results;
    const differenceDaysMargin = 15;

    const trimonthlyPlans = plans.filter(function(plan) {
        const ninetyDays = 90;
        return plan.sort !== PLAN_TYPE.SMART && Math.abs(parseInt(plan.duration) - ninetyDays) <= differenceDaysMargin;
    });

    const yearlyPlans = plans.filter(function(plan) {
        const oneYearInDays = 365;
        return (
            plan.sort !== PLAN_TYPE.SMART && Math.abs(parseInt(plan.duration) - oneYearInDays) <= differenceDaysMargin
        );
    });
    return { trimonthlyPlans, yearlyPlans };
};
export const subscriptionNotification = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.SUBSCRIPTION_NOTIFICATION, payload);
    return data;
};
export const getOffers = async (id = false) => {
    const api = configAxios();

    api.interceptors.response.use(successResponse, errorResponse);

    let url = ENDPOINTS.OFFERS;
    if (id) {
        url += `${id}/`;
    }
    const { data } = await api.get(url);
    return { offers: data };
};

export const getOffersQueries = async queriesStrings => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.OFFERS}${queriesStrings}`);
    return { data };
};

export const getEnterpriseOffersQueries = async (queriesStrings = '') => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.ENTERPRISE_OFFERS}${queriesStrings}`);
    return { data };
};

export const getOffersOpportunitysQueries = async queriesStrings => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.OFFERS_OPPORTYNITY}${queriesStrings}`);
    return { data };
};

export const getAnonymousOffer = async (id = false) => {
    const api = configAxios();
    let url = ENDPOINTS.ANONYMOUS_OFFER;
    if (id) {
        url += `${id}/`;
    }
    const { data } = await api.get(url);
    return { offers: data };
};

export const getAnonymousOffers = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.ANONYMOUS_OFFERS + '?page=1');
    return { offers: data };
};

export const getAnonymousOffersQueries = async queriesStrings => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.ANONYMOUS_OFFERS}${queriesStrings}`);
    return { data };
};

export const getSubscriptionOverview = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUBSCRIPTION_OVERVIEW).catch(error => {
        if (error.request.status == 404) {
            return { data: {} };
        }
    });
    return data;
};

export const changeInviteStatus = async data => {
    const api = configAxios(surveyMonkeyAPIBaseURL);
    await api.post(ENDPOINTS.CHANGE_INVITE_STATUS, data);
};

export const getSupplierDiscount = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.GET_SUPPLIER_DISCOUNT);
    return { supplierDiscount: data };
};
export const getSubscriptionLastFeedbackSeen = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUBSCRIPTION_LAST_FEEDBACK_SEEN);
    return { supplierLastSeen: data };
};
export const updateRatingLastSeen = async data => {
    const api = configAxios();
    await api.patch(ENDPOINTS.SUBSCRIPTION_LAST_FEEDBACK_SEEN, data);
};
export const getDrafts = async (draftId = false) => {
    const api = configAxios();
    const url = draftId ? `${ENDPOINTS.DRAFTS}${draftId}/` : ENDPOINTS.DRAFTS;
    const { data } = await api.get(url);
    return { drafts: data };
};
export const getQuotations = async (type = 'contractor') => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.CONTRACTOR_LIST_COMPETITIONS + `?user_type=${type}`);
    return { quotations: data };
};
export const getCanAnswerFeedback = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.CONTRACTOR_LAST_FEEDBACK_SEEN);
    return { contractorLastSeen: data };
};
export const updateRatingLastSeenContractor = async data => {
    const api = configAxios();
    await api.patch(ENDPOINTS.CONTRACTOR_LAST_FEEDBACK_SEEN, data);
};
export const removeCompetition = async payload => {
    const api = configAxios();
    await api.post(ENDPOINTS.REMOVE_COMPETITION, payload);
    return { success: true };
};
export const removeDraft = async draftId => {
    const api = configAxios();
    await api.delete(ENDPOINTS.DRAFTS + draftId + '/');
    return { success: true };
};
export const getSubscription = async () => {
    const api = configAxios();
    const { data, error } = await api.get(ENDPOINTS.SUBSCRIPTION).catch(error => {
        if (error.request.status == 404) {
            return { error: error };
        }
    });
    if (data) {
        return { data };
    } else return { error };
};
export const getContractor = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.CONTRACTORS);
    return data;
};
export const getSupplier = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUPPLIERS);
    return data;
};
export const postSupplier = async payload => {
    const api = configAxios();
    const { data, error } = await api.post(ENDPOINTS.SUPPLIERS, payload).catch(error => {
        if (error.request.status == 400) {
            return { error: error };
        }
    });
    if (data) {
        return { data };
    } else return { error };
};
export const postContractor = async payload => {
    const api = configAxios();
    const { data, error } = await api.post(ENDPOINTS.CONTRACTORS, payload).catch(error => {
        if (error.request.status == 400) {
            return { error: error };
        }
    });
    if (data) {
        return { data };
    } else return { error };
};
export const updateContractor = async (id, payload) => {
    const api = configAxios();
    const { data, error } = await api.put(`${ENDPOINTS.CONTRACTORS}${id}/`, payload).catch(error => {
        if (error.request.status == 400) {
            return { error: error };
        }
    });
    if (data) {
        return { data };
    } else return { error };
};
export const updateSupplier = async (id, payload) => {
    const api = configAxios();
    const { data, error } = await api.put(`${ENDPOINTS.SUPPLIERS}${id}/`, payload).catch(error => {
        if (error.request.status == 400) {
            return { error: error };
        }
    });
    if (data) {
        return { data };
    } else return { error };
};
export const getCheckSubscription = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUBSCRIPTION_CHECK);
    return data;
};

export const getCompetitionData = async id => {
    const api = configAxios();
    const data = api.get(`competitions/${id}/`);
    return data;
};
export const getCompetitionProposals = async id => {
    const api = configAxios();
    const { data } = await api.get(`competition_proposals/${id}/`);
    return data;
};
export const toggleInvitations = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.TOGGLE_INVITATIONS, data);
};
export const toggleProposals = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.TOGGLE_PROPOSALS, data);
};
export const getSupplierContact = async supplierId => {
    const api = configAxios();
    const { data, error } = await api.get(ENDPOINTS.SUPPLIER_CONTACT + supplierId).catch(error => {
        if (error.request.status == 401) {
            return { error: false };
        }
    });
    if (data) {
        return data;
    } else {
        return error;
    }
};
export const getSupplierContactByEmail = async supplierEmail => {
    const api = configAxios();
    const { data, error } = await api
        .get(ENDPOINTS.SUPPLIER_CONTACT_BY_EMAIL + '?supplier_email=' + supplierEmail)
        .catch(error => {
            if (error.request.status == 401) {
                return { error: false };
            }
        });
    if (data) {
        return data;
    } else {
        return error;
    }
};
export const getTotalOfSentProposalsInCompetition = async competitionId => {
    const api = configAxios();
    const { data } = await api.get(`get_total_of_sent_proposals_in_competition/${competitionId}/`);
    return data;
};
export const downloadCompetitionMap = async competitionId => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.DOWNLOAD_COMPETITION_MAP + competitionId + '/');
    const blob = new Blob(['\ufeff', data]);
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = 'mapa_concorrencia.xlsx';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
export const updateInvitationEmail = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.CHANGE_INVITE_EMAIL, data);
};

export const sendRevisionRequest = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.SEND_REVISION_REQUEST, data);
};
export const resendInvites = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.RESEND_INVITES, data);
};
export const inviteAdditionalSuppliers = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.INVITE_ADDITIONAL_SUPPLIERS, data);
};
export const getPendingQuotationsWinners = async url => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.PENDING_QUOTATIONS_WINNERS + url);
    return data;
};
export const sendFeedback = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.COMPETITION_WINNER, data);
};

export const createRandomPasswordContractor = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.RANDOM_PASSWORD_CONTRACTOR, payload);
    return data;
};

export const downloadComercialProposal = async id => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.DOWNLOAD_COMERCIAL_PROPOSAL}?proposal=${id}`);
    return data;
};

export const getAmounts = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.GET_AMOUNTS);
    return data;
};
export const getCompetitions = async competitionId => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.COMPETITIONS}${competitionId}`);
    return data;
};

export const saveDrafts = async (payload, draftId) => {
    const api = configAxios();
    if (draftId && draftId > 0) {
        const { data, error } = await api.patch(ENDPOINTS.DRAFTS + draftId + '/', payload).catch(error => {
            return error;
        });
        return error ? error : data;
    } else {
        const { data, error } = await api.post(ENDPOINTS.DRAFTS, payload).catch(error => {
            return error;
        });
        return error ? error : data;
    }
};
export const sendEditCompetitionRequest = async (update, id) => {
    const api = configAxios();
    const { data, error } = await api.put(ENDPOINTS.EDIT_COMPETITION + id + '/', update).catch(error => {
        return error;
    });
    return error ? error : data;
};
export const createQuotation = async payload => {
    const api = configAxios();
    const { data, error } = await api.post(ENDPOINTS.CREATE_COMPETITION, payload).catch(error => {
        return error;
    });
    return error ? error : data;
};
export const hasOccupation = async id => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.HAS_OCCUPATION}${id}/`);
    return data;
};
export const createOccupation = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.CREATE_OCCUPATION, payload);
    return data;
};
export const loadMoreOffers = async nextOffersPage => {
    const api = configAxios();
    const { data } = await api.get(nextOffersPage).catch(error => {
        if (error.request.status == 404) {
            return false;
        }
    });
    const { results, next } = data;
    return { results, next };
};
export const filterOffers = async (filter, user) => {
    const api = configAxios();
    let url = user ? ENDPOINTS.OFFERS : ENDPOINTS.ANONYMOUS_OFFERS;
    if (filter.state) {
        url = appendQueryString(url, `competition__construction_state=${filter.state}`);
    }
    if (filter.search) {
        url = appendQueryString(url, `search=${filter.search}`);
    }
    if (filter.freeOffers) {
        url = appendQueryString(url, 'free_offers=true');
    }
    const { data } = await api.get(url);
    return data;
};
export const sendContactUsRequest = async form => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.CONTACT_US, form);
    return data;
};
export const listCondoTechsPartners = async (queriesStrings = '') => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.CONDOTECH_LIST_PARTNERS}${queriesStrings}`);
    return data;
};
export const sendContactUsRequestCondTech = async form => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.CONDOTECH_NOTIFICATION, form);
    return data;
};
export const getCondoTechsDetails = async partnerId => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.CONDOTECHS_DETAILS}${partnerId}`);
    return data;
};
export const addToBlacklist = async data => {
    const api = configAxios();
    await api.post(ENDPOINTS.UNSUBSCRIBE, data);
};
export const addToBlacklistMarketing = async data => {
    const api = configAxiosCampaign();
    await api.post(ENDPOINTS.BLACKLIST_EMAIL, data);
};

export const recoverPassword = async payload => {
    const api = configAxios();
    const { error } = await api.post(ENDPOINTS.RECOVER_PASSWORD, payload).catch(error => {
        if (error.request.status == 401) {
            return { error };
        }
    });
    if (error) {
        return { error };
    } else return true;
};

export const validTokenRecoverPassword = async token => {
    const api = configAxios();
    const { error, data } = await api.get(`${ENDPOINTS.SET_NEW_PASSWORD}?token=${token}`).catch(error => {
        if (error.request.status == 401) {
            return { error };
        }
    });
    if (error) {
        return { error };
    } else return data;
};

export const changePassword = async payload => {
    const api = configAxios();
    const { data, error } = await api.post(ENDPOINTS.SET_NEW_PASSWORD, payload).catch(error => {
        if (error.request.status == 401) {
            return { error };
        }
    });
    if (data) {
        return { data };
    } else {
        return { error };
    }
};

export const getBalancePackages = async () => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.LIST_BALANCE_PACKAGES}`);
    return data;
};

export const setPurchaseActionLog = async payload => {
    const api = configAxios();
    const { data } = await api.post(`${ENDPOINTS.SAVE_PURCHASE_ACTION_LOG}`, payload);
    return data;
};
export const sendProposal = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.CREATE_PROPOSAL, payload);
    return data;
};

export const sendCreditReversalRequest = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.SEND_CREDIT_REVERSAL_REQUEST, payload);
    return data;
};
export const getContractorPartner = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.GET_CONTRACTOR_PARTNER).catch(e => {
        console.error(e);
        return { data: false };
    });
    return data;
};
export const sendNotificationCheckout = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.CHECKOUT_NOTIFICATION, payload);
    return data;
};

export const getBannerText = async (queriesStrings = '') => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.BANNER_TEXTS}${queriesStrings}`);
    return data;
};

export const getCrossSalerComplement = async () => {
    const api = configAxios();

    api.interceptors.response.use(successResponse, errorResponse);

    const { data } = await api.get(`${ENDPOINTS.CROSS_SELLER}`);
    return data;
};

export const getSupplierProfileNetwork = async (queryString = '') => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUPPLIER_PROFILE_NETWORK + queryString);
    return data;
};

export const getSupplierPhoneComplete = async (queryString = '') => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUPPLIER_PROFILE_NETWORK + queryString + '/phone');
    return data;
};

export const sendAssociateComplementContactUs = async (id, payload) => {
    const api = configAxios();
    const { data } = await api.post(`${ENDPOINTS.CONTACT_US}${id}/associate_complement/`, payload);
    return data;
};

export const sendAssociateComplementSubscriptionNotification = async (id, payload) => {
    const api = configAxios();
    const { data } = await api.post(`${ENDPOINTS.SUBSCRIPTION_NOTIFICATION}${id}/associate_complement/`, payload);
    return data;
};
export const createStructuredCompetition = async payload => {
    const api = configAxios();
    const { data } = await api.post(ENDPOINTS.STRUCTURED_COMPETITION, payload);
    return data;
};
export const occupationResponse = async (id, type) => {
    const api = configAxios();
    const { data } = await api.put(`${ENDPOINTS.CONFIRM_OCCUPATION}${id}/${type}/`);
    return data;
};

export const createPostponeQuotation = async payload => {
    const api = configAxios();
    const { data, error } = await api.post(ENDPOINTS.POSTPONE_QUOTATION, payload).catch(error => {
        if (error.request.status == 400) {
            return { error: error };
        }
    });
    if (data) {
        return { data };
    } else return { error };
};
export const addSuppliersInStructeredCompetition = async (id, suppliers) => {
    const api = configAxios();
    await api.put(ENDPOINTS.CREATE_STRUCTERED_COMPETITION + id + '/select_suppliers/', suppliers);
};

export const getPostFromCondoNew = async () => {
    const {data} = await axios({
        method: 'get',
        url: 'https://condo.news/wp-json/wp/v2/posts?_embed=wp:featuredmedia&per_page=3',
        responseType: 'json'
    });
    return data;
};

export const getExtraSlotOffers = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.OFFERS_SLOT_EXTRA);
    return { data }
}

export const createEngelinkCreditContact = async (payload) => {
    const api = configAxiosEngelinkCredit();
    const { data } = await api.post(ENDPOINTS.LEAD_CREDITS, payload);
    return data;
};

export const getParticipants = async (id) => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.SUPPLIERS_PARTICIPATING + id);
    return data;
};